import './HadisIndex.css'

function HadisIndex({ selectTopic, setTopic, setPage }) {
    let index = [
        "ঈমান",
        "নামায",
        "হজ্জ ",
        "রোজা",
        "কবর",
        "কিয়ামত ",
        "আখিরাত",
        "জাহান্নাম",
        "সাওম ",
        "পবিত্রতা ",
        "বিশ্বাস",
        "বিতর নামায",
        "কদর",
        "কাউসার",
        " শাফাআত",
        " মাকামে মাহমূদ",
        " হুর",
        " হিসাব",
        " আমলনামা",
        " আমল",
        " মীযান",
        " হাশর",
        " লাওহে মাহফুয",
        " সিদরাতুল মুনতাহা",
        "বায়তুল মামুর",
        "ইল্লীন",
        " বারযাখ",
        "নিয়ত",
        "তাওহিদ",
        "রিসালাত",
        "সালাত",
        "যাকাত",
        "সাওম",
        "হজ",
        "শাহাদাত",
        "দাওয়াত",
        "দল",
        "প্রশিক্ষণ",
        "কুরআন",
        "আনুগত্য",
        "তাকওয়া",
        "পর্দা",
        "বাইয়াত",
        "তাওবা",
        "কুরবানি",
        "ত্যাগ",
        "রাষ্ট্র",
        "জান্নাত",
        "আত্মশুদ্ধি",
        "জিহাদ",
        "পানাহার",
        "হারাম",
        "হালাল",
        "খাবার",
        "দোয়া",
        "ক্ষমা",
        "দয়া",
        "দান",
        "মদ",
        "নেশা",
        "আরশ",
        "আসমান",
        "জমিন",
        "কৃপণ",
        "কৃপণতা",
        "ঈদ",
        "ফিতর",
        "ফেতরা",
        "ফিতরা",
        "আযহা",
        "কালিমা",
        "হায়েজ",
        "ঋতু",
        "বীর্য",
        "নাপাক",
        "ফজর",
        "আসর",
        "মাগরিব",
        "ইশা",
        "জোহর",
        "যোহর",
        "জুমা",
        "তাকদীর",
        "অহংকার",
        "লোভ",
        "ভালোবাসা",
        "ঝগড়া",
        "হিংসা",
        "বিবাদ",
        "ওযু",
        "উযু",
        "বিবাহ",
        "গোসল",
        "সুদ",
        "ঘুষ",
        "যুদ্ধ",
        "আজান",
        "নফল",
        "সালাম",
        "তাকদির",
        "শত্রুতা",
        "যাদু",
        "সংযম",
        "গান",
        "সঙ্গীত",
        "ফেরেশতা",
        "ফিতনা",
        "বেদাত",
        "দাজ্জাল",
        "কেয়ামত",
        "কিয়ামত",
        "ধৈর্য",
        "শান্তি",
        "তওবা",
        "ক্রন্দন",
        "শাস্তি",
        "খুতবা",
        "জান্নাতুল ফেরদাউস",
        "জ্ঞান",
        "জ্ঞানী",
        "জ্ঞান অর্জন",
        "শহীদ",
        "পোশাক",
        "স্বামী",
        "স্ত্রী",
        "সন্তান",
        "সুগন্ধী",
        "বন্ধুত্ব",
        "যিকর",
        "জিকির",
        "মসজিদ",
        "রহমত",
        "বরকত",
        "হেদায়াত",
        "হিদায়াত",
        "মাগফিরাত",
        "অভিশাপ",
        "অভিসম্পাত",
        "সুন্নাত",
        "সুন্নত",
    ]
    let items = new Set();
    for (let i = 0; i < index.length; i++) {
        let word = index[i];
        while (word.startsWith(" ")) word = word.substring(1, word.length);
        while (word[word.length - 1] === ' ') word = word.substring(0, word.length - 1);
        items.add(word);
    }
    index = Array.from(items);
    index.sort();
    return (
        <>
            <div class="scroller">
                {index.map((item) => {
                    return <div className='item' onClick={() => { selectTopic(item); setTopic(item); setPage(0) }}>{item}</div>
                })}
            </div>
        </>
    );
}
export default HadisIndex;